export class WorkflowStateTypes {
    ID?: number;
    NAME?: string;
    DESCRIPTION?: string;
    ACTION?: string;
    CREATED_BY?: string;
    CREATED_DATE?: Date;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: Date;
}
